// Industrial Authority Package — campaign landing-page constants
import { COMPANY } from "./constants";

export const PACKAGE = {
  name: "The Industrial Authority Package",
  kicker: "Website + 8-Page Print Brochure",
  promise: "Build trust. Establish authority. Generate more industrial leads.",
  priceOriginal: "₹12,000",
  priceNow: "₹10,000",
  priceBadge: "Limited Time Offer",
  flyerImage:
    "https://customer-assets.emergentagent.com/job_business-growth-hub-44/artifacts/72eokwhr_10K%20Flyer%20Updated.png",
  contact: {
    phone: COMPANY.phone,
    phoneDisplay: COMPANY.phoneDisplay,
    whatsapp: COMPANY.whatsapp,
    email: COMPANY.email,
  },
};

export const PACKAGE_BROCHURE_PAGES = [
  {
    n: "01",
    title: "Company Overview",
    body:
      "Your founding story, mission and values — written to anchor trust on the very first page.",
  },
  {
    n: "02",
    title: "Our Services",
    body:
      "Plant engineering, fabrication, installation, maintenance & consulting — cleanly laid out.",
  },
  {
    n: "03",
    title: "Our Approach",
    body:
      "Plan → Build → Deliver → Support. A visual cycle that explains how you actually work.",
  },
  {
    n: "04",
    title: "Key Projects",
    body:
      "Hero shots and one-line wins from your strongest 4–6 case studies.",
  },
  {
    n: "05",
    title: "Why Choose Us",
    body:
      "Experienced team · Quality assurance · Timely delivery · Customer-focused · Safety first.",
  },
  {
    n: "06",
    title: "Industries We Serve",
    body:
      "Manufacturing, Oil & Gas, Power, Infrastructure, Pharmaceuticals — your verticals, your language.",
  },
  {
    n: "07",
    title: "Technology & Innovation",
    body:
      "Show off the tooling, software and engineering practices that future-proof your delivery.",
  },
  {
    n: "08",
    title: "Let's Build the Future Together",
    body:
      "A compelling closing spread with your contact details and a clear next step.",
  },
];

export const PACKAGE_FEATURES = [
  {
    icon: "MessageCircle",
    title: "WhatsApp Integration",
    body:
      "Floating WhatsApp button + click-to-chat across every page. Connect instantly and never miss a potential lead.",
  },
  {
    icon: "TrendingUp",
    title: "SEO Optimized",
    body:
      "On-page SEO, schema markup, sitemap & robots. Rank higher on Google and attract more organic traffic.",
  },
  {
    icon: "ClipboardList",
    title: "Lead Capture",
    body:
      "Smart contact forms that capture inquiries and convert visitors into customers — straight to your inbox.",
  },
  {
    icon: "Phone",
    title: "Click to Call",
    body:
      "One-tap calling buttons across the site for quick and easy customer connection on every device.",
  },
];

export const PACKAGE_INDUSTRIES = [
  "Manufacturing",
  "Oil & Gas",
  "Power",
  "Infrastructure",
  "Pharmaceuticals",
  "Chemicals",
  "Construction",
  "MSMEs",
];

export const PACKAGE_WEBSITE_FEATURES = [
  "Custom industrial design language",
  "Mobile-first responsive layout",
  "Home, About, Services, Projects & Contact pages",
  "Stats / KPI strip on the hero",
  "Hero CTAs + sticky 'Get a Quote' button",
  "Google Analytics setup",
  "Domain & hosting guidance",
];

export const PACKAGE_BROCHURE_FEATURES = [
  "8 fully designed pages",
  "Print-ready CMYK artwork (PDF)",
  "Industrial photography & layout",
  "Brand-consistent typography",
  "Ready for print or PDF email-out",
];

export const PACKAGE_TIMELINE = [
  { step: "Day 1", title: "Discovery", body: "30-min brief to lock content, structure and visual direction." },
  { step: "Day 2–3", title: "Build & content", body: "Site coded, brochure typeset, copy polished and reviewed." },
  { step: "Day 4", title: "Launch & handover", body: "Site goes live and the brochure ships as print-ready PDF." },
];

export const PACKAGE_FAQS = [
  {
    q: "What does ₹10,000 actually cover?",
    a: "A 5-page custom website (Home, About, Services, Projects, Contact) PLUS a fully designed 8-page print brochure with print-ready PDF artwork. WhatsApp integration, SEO basics, lead capture forms and click-to-call are all included.",
  },
  {
    q: "How long until I go live?",
    a: "Standard delivery is 4 working days, assuming we receive your content (logos, photos, project list) within 24 hours of kickoff.",
  },
  {
    q: "Do I own the website and brochure files?",
    a: "Yes — you get the full source code of the website and the print-ready PDF of the brochure on final handover. Editable design source files (Figma / Adobe) are not part of this package.",
  },
  {
    q: "Is hosting and domain included?",
    a: "Domain registration and the first year of hosting are guided / supported; actual domain + hosting fees are billed at cost (typically ₹1,500–₹3,000/year).",
  },
  {
    q: "Can I get printed brochures too?",
    a: "Yes — we can quote local print at actual cost (Pune/PAN-India). The ₹10,000 covers the design + print-ready artwork.",
  },
  {
    q: "Is there a money-back guarantee?",
    a: "We work in approval gates. If you're not happy after the first design draft, you pay only for the discovery + wireframes (₹2,000) and we part ways amicably.",
  },
];
